import { Button } from '../../../cdl/Button/Button';
import { Tooltip } from '../../../cdl/Tooltip/Tooltip';
import { translate } from '../../../common/helpers/translate.helper';
import { IconPlus } from '../../../common/icons/cdl/Plus';

interface AdditionalOfferActionButtonProps {
    disabledReason?: string;
    onClick?: () => void;
}

export const AdditionalOfferActionButton = ({ disabledReason, onClick }: AdditionalOfferActionButtonProps) => {
    const button = (
        <Button LeadingIcon={IconPlus} disabled={!!disabledReason} onClick={onClick}>
            {translate('statusbar.supplier.addAlternativeQuote.button')}
        </Button>
    );

    if (!disabledReason) {
        return button;
    }

    return (
        <Tooltip label={disabledReason} showArrow maxWidth="160px">
            {button}
        </Tooltip>
    );
};
